import levenshtein from 'fast-levenshtein';

// This method is used to find the similarity between two strings.
export const similarityPercentage = (a?: string, b?: string) => {
	const distance = levenshtein.get(a || '', b || '');
	const similarity = 1 - distance / Math.max(a?.length || 0, b?.length || 0) || 0;
	return similarity * 100;
};
